import * as Actions from './actions'
import initialState from '../store/initialState'

export const AppleReducer = (state = initialState.apple, action: any) => {
    switch (action.type) {
        case Actions.SET_APPLE_VALUE:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}